<template>
  <div id="modify">
    <el-dialog custom-class="" :show-close="false" width="400px" :close-on-click-modal="true" center
               :visible="isLogin">
      <div class="dialog-content">
        <div class="dialog-content-left">
          <div class="dialog-content-left-name">
            <p>修改手机号</p>
          </div>
        </div>
        <div class="dialog-content-right">
          <!--            手机验证码登录-->
          <div style="position: relative;top: 20px;">
            <el-form :model="loginUser" :rules="rules" status-icon ref="ruleForm" class="demo-ruleForm">
              <el-form-item prop="phone">
                <el-input prefix-icon="el-icon-user-solid" placeholder="请输入新手机号"
                          v-model="loginUser.phone"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input prefix-icon="el-icon-view" placeholder="请输入验证码" v-model="loginUser.code">
                  <el-button slot="append" @click="getCodeHandle" :disabled="getCode"> {{ getCodeText }}</el-button>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="medium" id="submit-id" type="primary" @click="Login" :loading="btnLoading">保存
                </el-button>
                <el-button size="medium" id="submit-id" type="primary" @click="quxiao">取消
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 图形验证码弹窗 -->
    <div v-if="captchaVisible" class="captcha-overlay">
      <div class="captcha-box">
        <p class="captcha-title">请输入图形验证码</p>
        <div class="captcha-img-row">
          <img :src="captchaImg" @click="refreshCaptcha" class="captcha-img" title="点击刷新" />
          <span @click="refreshCaptcha" class="captcha-refresh">换一张</span>
        </div>
        <el-input v-model="captchaInput" placeholder="请输入验证码"
                  @keyup.enter.native="confirmCaptcha" class="captcha-input"></el-input>
        <div class="captcha-btns">
          <el-button size="small" @click="cancelCaptcha">取消</el-button>
          <el-button size="small" type="primary" @click="confirmCaptcha">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getUserLoginPhoneCode, getCodeImg} from "@/api/loginApi";
import {modifyPhone} from "@/api/userApi";

export default {
  props: [
    'isLogin'],
  data() {
    // 用户名的校验方法
    let validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      }
      // 用户名以字母开头,长度在5-16之间,允许字母数字下划线
      const userNameRule = /^[\d]{11}$/;
      if (!userNameRule.test(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      return callback();
    };
    // 验证码的校验方法
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入验证码"));
      }
      return callback();
    };
    return {
      getCodeText: '获取验证码',
      btnLoading: false,
      timer:'',
      loginUser: {
        phone: '',
        code: '',
      },
      getCode: false, // 控制1分钟内才能进行再次发送验证码
      // 图形验证码
      captchaVisible: false,
      captchaImg: '',
      captchaUuid: '',
      captchaInput: '',
      captchaCallback: null,
      // 用户信息校验规则,validator(校验方法),trigger(触发方式),blur为在组件 Input 失去焦点时触发
      rules: {
        phone: [{
          validator: validatePhone,
          trigger: "blur"
        }],
        code: [{
          validator: validateCode,
          trigger: "blur"
        }]
      },
    }
  }
  ,
  methods: {
    // 显示图形验证码弹窗
    async showCaptcha(callback) {
      this.captchaCallback = callback;
      this.captchaInput = '';
      this.captchaVisible = true;
      try {
        const res = await getCodeImg();
        if (res && res.img) {
          this.captchaImg = 'data:image/jpg;base64,' + res.img;
          this.captchaUuid = res.uuid;
        }
      } catch (e) {
        this.$message.error('获取验证码失败，请重试');
        this.captchaVisible = false;
      }
    },
    // 刷新验证码
    async refreshCaptcha() {
      try {
        const res = await getCodeImg();
        if (res && res.img) {
          this.captchaImg = 'data:image/jpg;base64,' + res.img;
          this.captchaUuid = res.uuid;
          this.captchaInput = '';
        }
      } catch (e) {
        this.$message.error('刷新验证码失败');
      }
    },
    // 确认验证码
    confirmCaptcha() {
      if (!this.captchaInput || this.captchaInput.trim() === '') {
        this.$message.warning('请输入图形验证码');
        return;
      }
      this.captchaVisible = false;
      if (this.captchaCallback) {
        this.captchaCallback(this.captchaUuid, this.captchaInput.trim());
      }
    },
    // 取消验证码
    cancelCaptcha() {
      this.captchaVisible = false;
      this.captchaInput = '';
    },
    //获取验证码
    async getCodeHandle() {
      if (this.loginUser.phone === "") {
        this.$message.error("手机号不能为空")
        return
      }
      var reg = /^1[3-9]\d{9}$/;
      if (this.loginUser.phone.length === 11) {
        if (!reg.test(this.loginUser.phone)) {
          this.$message.error("请输入正确的手机号")
          return
        }
      } else {
        return
      }
      // 弹出图形验证码
      this.showCaptcha((captchaUuid, captchaCode) => {
        this.getCode = true
        this.sendTime = 60;
        this.getCodeText = "重新发送(" + this.sendTime + ")"
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (this.sendTime > 0) {
            this.sendTime--;
            this.getCodeText = "重新发送(" + this.sendTime + ")"
          } else {
            this.getCode = false;
            this.getCodeText = "获取验证码"
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        getUserLoginPhoneCode({
          phone: this.loginUser.phone,
          captchaUuid: captchaUuid,
          captchaCode: captchaCode
        }).then((res) => {
        }).catch(() => {
          this.getCode = false;
          this.getCodeText = "获取验证码"
          if (this.timer) { clearInterval(this.timer); this.timer = null; }
        })
      });
    },
    // 修改手机号
    Login() {
      // 通过element自定义表单校验规则，校验用户输入的用户信息
      this.$refs["ruleForm"].validate(valid => {
        //如果通过校验开始登录
        if (valid) {
          this.btnLoading = true
          modifyPhone(this.loginUser).then((res) => {
            if (res.code === 200) {
              // 隐藏登录组件
              this.$emit('quxiao',false)
              // 弹出通知框提示登录成功信息
              this.notifySucceed(res.msg);
              this.$refs["ruleForm"].resetFields();
            } else {
              // 清空输入框的校验状态
              this.$refs["ruleForm"].resetFields();
              // 弹出通知框提示登录失败信息
              this.notifyError(res.data.msg);
            }
          }).finally(() => {
            this.getCode = false;
            this.getCodeText = "获取验证码"
            clearInterval(this.timer); // 清除定时器
            this.timer = null;
            this.btnLoading = false
            this.$emit('shuaxin')
          })
          return true
        } else {
          return false;
        }
      });
    },
    // 取消
    quxiao(){
      this.getCode = false;
      this.getCodeText = "获取验证码"
      clearInterval(this.timer); // 清除定时器
      this.timer = null;
      this.$emit('quxiao',false)
    }
  }

}

</script>

<style>
.dialog-login {
  position: relative;
  border-radius: 0.925rem;
}

/* 图形验证码弹窗 */
.captcha-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.captcha-box {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 160px;
  text-align: center;
}
.captcha-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333;
}
.captcha-img-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.captcha-img {
  height: 40px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.captcha-refresh {
  color: #409EFF;
  cursor: pointer;
  margin-left: 8px;
  font-size: 12px;
}
.captcha-input {
  margin-bottom: 16px;
}
.captcha-btns {
  display: flex;
  justify-content: space-between;
}
</style>
